import Home from "./pages/Home";
import ScrollToTop from "./components/ScrollToTop";
const App = () => {
  return (
    <div>
      <Home />
      <ScrollToTop />
    </div>
  )
}
export default App;